// 引入公共模块
import {
  mergeParams,
  addParamsToLinksHandler,
  pageJumpHandler,
  pageJumpBlankHandler,
  initScrollHandler,
  initNavBarHandler,
} from './common.js';

// 命名空间模式
const App = {
  init() {
    addParamsToLinksHandler(mergeParams()); //为链接添加参数
    pageJumpHandler(); //页面跳转
    pageJumpBlankHandler(); // 页面跳转(新窗口打开)
    initScrollHandler(); // 滚动处理
    initNavBarHandler(); // 导航下拉处理
    this.initCaseBook(); //实践案例集弹窗
    this.caseBtnHandler();
  },
  initCaseBook() {
    //实践案例集弹窗
    $('.activity-modal-close').on('click', () => {
      // 隐藏弹窗
      $('.activity-modal').addClass('activity-modal-hidden');
      // 恢复页面滚动
      $('body').removeClass('scroll-lock');
    })
    // 实践案例左下角
    $('.cases-casebook-close').on('click', () => {
      // 隐藏弹窗
      $('.cases-casebook-container').addClass('cases-casebook-hidden');
    })
  },
  caseBtnHandler() {
    $(".caseDownloadBtn").on('click', function(e) {
      // 阻止默认的点击行为
      e.preventDefault();
      // 获取链接参数
      const params = JSON.parse(localStorage.getItem('params'));
      // 获取链接的href属性
      const url = $(this).attr('href');
      const queryString = Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
      window.open(queryString ? `${url}?${queryString}` : url, '_blank')
    })
  }
};

// 文档加载后初始化
$(function () {
  App.init();
});
